import {Directive, ElementRef, EventEmitter, Inject, OnDestroy, OnInit, Optional, Output} from '@angular/core';
import {filter, fromEvent, Subscription} from 'rxjs';
import {DOCUMENT} from '@angular/common';

@Directive({
  selector: '[outsideClick]',
  standalone: false
})
export class OutsideClickDirective implements OnInit, OnDestroy {
  @Output('outsideClick') outsideClick = new EventEmitter<MouseEvent>();

  private subscription: Subscription | undefined;

  constructor(private element: ElementRef, @Optional() @Inject(DOCUMENT) private document: any) {
  }

  private static isOrContainsClickTarget(element: HTMLElement, clickTarget: HTMLElement) {
    return element == clickTarget || element.contains(clickTarget);
  }

  ngOnInit() {
    setTimeout(() => {
      this.subscription = fromEvent<MouseEvent>(this.document, 'click')
        .pipe(
          filter(event => {
            const clickTarget = event.target as HTMLElement;
            return !OutsideClickDirective.isOrContainsClickTarget(this.element.nativeElement, clickTarget);
          }),
        )
        .subscribe(event => this.outsideClick.emit());
    }, 0);
  }

  ngOnDestroy() {
    if (this.subscription) this.subscription.unsubscribe();
  }
}
